import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getSelectedLanguage } from "./Utils";
import translationEN from "./Locales/EN/translation.json";
import translationFR from "./Locales/FR/translation.json";
import translationAR from "./Locales/AR/translation.json";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

const savedLanguage = getSelectedLanguage();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    lng: savedLanguage || "fr",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    ns: ["translation"],
    defaultNS: "translation",
    react: {
      useSuspense: false,
    },
  });

export default i18n;
